"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
// Special element: Anchor

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Specification = require("../../specification");

var mark_1 = require("./mark");

var AnchorElement =
/*#__PURE__*/
function (_mark_1$MarkClass) {
  _inherits(AnchorElement, _mark_1$MarkClass);

  function AnchorElement() {
    var _this;

    _classCallCheck(this, AnchorElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnchorElement).apply(this, arguments)); // Get a list of elemnt attributes

    _this.attributeNames = ["x", "y"];
    _this.attributes = {
      x: {
        name: "x",
        type: Specification.AttributeType.Number
      },
      y: {
        name: "y",
        type: Specification.AttributeType.Number
      }
    };
    return _this;
  } // Initialize the state of an element so that everything has a valid value


  _createClass(AnchorElement, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.x = 0;
      attrs.y = 0;
    } // Get bounding rectangle given current state

  }, {
    key: "getHandles",
    value: function getHandles() {
      return []; // let attrs = this.state.attributes as AnchorElementAttributes;
      // let { x, y } = attrs;
      // return [
      //     <Handles.Point>{
      //         type: "point",
      //         x: x, y: y,
      //         actions: []
      //     }
      // ]
    } // /** Get link anchors for this mark */
    // public getLinkAnchors(): LinkAnchor.Description[] {
    //     let attrs = this.state.attributes;
    //     return [
    //         {
    //             element: this.object._id,
    //             points: [
    //                 { x: attrs.x, y: attrs.y, xAttribute: "x", yAttribute: "y", direction: { x: 0, y: 1 } }
    //             ]
    //         }
    //     ];
    // }

  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var props = this.object.properties;
      return [manager.label("(drag the anchor in the glyph editor)")];
    }
  }], [{
    key: "createDefault",
    value: function createDefault(glyph) {
      var element = _get(_getPrototypeOf(AnchorElement), "createDefault", this).call(this, glyph);

      element.mappings.x = {
        type: "parent",
        parentAttribute: "icx"
      };
      element.mappings.y = {
        type: "parent",
        parentAttribute: "icy"
      };
      return element;
    }
  }]);

  return AnchorElement;
}(mark_1.MarkClass);

AnchorElement.classID = "mark.anchor";
AnchorElement.type = "mark";
AnchorElement.metadata = {
  displayName: "Anchor",
  iconPath: "mark/anchor"
};
exports.AnchorElement = AnchorElement;